import { post } from '../utils/fetch';

export const postSurveyData = (payload) =>
  post('/api/survey/post_intake/', payload);
